<template>
  <div class="outset_div">
    <div class="content">
      <div class="item">
        <div class="label required">姓名</div>
        <div class="value">
          <van-field :disabled="disabledName" name="name" v-model="form.name" maxlength="20" placeholder="请输入" />
        </div>
      </div>
      <van-divider />
      <div class="item">
        <div class="label required">手机号</div>
        <div class="value">
          <van-field
            name="mobile"
            @blur="blurMobile"
            v-model="form.mobile"
            placeholder="请输入"
            type="tel"
            :disabled="$route.name == $RouterName.VISITOR_OWNER_EDIT"
          />
        </div>
      </div>
      <van-divider />
      <div class="item">
        <div class="label required">类型</div>
        <div class="value">
          <van-field
            v-model="pageText.house_user_type_text"
            is-link
            readonly
            name="picker"
            placeholder="请选择"
            @click="typePicker.show = true"
          />
          <van-popup v-model:show="typePicker.show" position="bottom">
            <van-picker :columns="typePicker.columns" @confirm="typePicker.confirm" @cancel="typePicker.show = false" />
          </van-popup>
        </div>
      </div>
      <van-divider />
      <div class="item" style="padding-bottom:16px" v-if="$route.query.start">
        <div class="label">可通行日期</div>
        <div class="value">
          <van-field
            :modelValue="generalPicker.info.label"
            is-link
            readonly
            placeholder="请选择"
            @click="generalPicker.show = true"
          />
          <uf-daterange-picker
            :minDateProps="moment($route.query.start).toDate()"
            :maxDateProps="moment($route.query.end).toDate()"
            v-model:show="generalPicker.show"
            v-model="generalPicker.date"
          />
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button type="primary" block @click="submit">提交</van-button>
    </div>
  </div>
</template>

<script>
import { computed, reactive, ref } from "vue";
import { toRefs } from "@vueuse/core";
import validate from "@/utils/validate";
import { Toast } from "vant";
import { storesManageService, userService } from "@/service";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import { RouterName } from "@/router";
import { Notify } from "vant";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const out_userid = ref("");

    const showPicker = ref(false);

    const generalPicker = reactive({
      date: [],
      show: false,
      info: computed(() => {
        if (generalPicker.date.length === 0) {
          return {
            label: "",
            start_time: "",
            end_time: ""
          };
        } else {
          const start = moment(generalPicker.date[0]);
          const end = moment(generalPicker.date[1]);
          return {
            label: `${start.format("YYYY.MM.DD")}-${end.format("YYYY.MM.DD")}`,
            start_time: start.format("YYYY-MM-DD"),
            end_time: end.format("YYYY-MM-DD")
          };
        }
      })
    });

    const typePicker = reactive({
      show: false,
      columns: ["租户", "业主"],
      confirm(val) {
        pageText.house_user_type_text = val;
        data.form.house_user_type = val == "租户" ? "2" : "1";
        typePicker.show = false;
      }
    });

    const pageText = reactive({ house_user_type_text: "" });

    const data = reactive({
      form: {
        role_id: "8",
        house_id: route.query.house_id,
        name: "",
        mobile: "",
        house_user_type: "",
        date_start: "",
        date_end: ""
      }
    });

    const afterRead = file => {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    };

    const submit = async () => {
      if (data.form.name == "") {
        Toast("请输入姓名");
        return;
      }
      if (!validate.name.reg.test(data.form.name)) {
        Toast("姓名" + validate.name.msg);
        return;
      }
      if (!validate.mobile.reg.test(data.form.mobile)) {
        Toast(validate.mobile.msg);
        return;
      }

      if (data.form.house_user_type == "") {
        Toast("请选择类型");
        return;
      }

      const obj = { ...data.form };

      if (generalPicker.info.start_time) obj.date_start = generalPicker.info.start_time;
      if (generalPicker.info.end_time) obj.date_end = generalPicker.info.end_time;

      if (route.query.userId) {
        await storesManageService.userEdit({
          out_userid: out_userid.value,
          id: route.query.userId,
          ...obj
        });
      } else {
        await storesManageService.userAdd(obj);
      }

      router.back();
    };

    const getUserInfo = async () => {
      const { data: res } = await userService.userInfo({
        user_id: route.query.userId,
        user_information: 1
      });
      const house_json = res.data.house_json[0];
      pageText.house_user_type_text = house_json.house_user_type_name;

      out_userid.value = res.data.out_userid;

      data.form.name = res.data.name; //姓名 必填
      data.form.mobile = res.data.mobile; //
      data.form.house_user_type = house_json.house_user_type;

      if (res.data.house_json.length && house_json.date_start) {
        generalPicker.date = [house_json.date_start, house_json.date_end];
      }
    };

    if (route.query.userId) getUserInfo();

    const disabledFlag = ref(false);
    const blurMobile = async () => {
      if (!validate.mobile.reg.test(data.form.mobile)) {
        Toast(validate.mobile.msg);
        disabledFlag.value = false;
        return;
      }
      try {
        await userService.check_user({ mobile: data.form.mobile });
        disabledFlag.value = false;
      } catch (error) {
        if (error.data) {
          if (error.data.user_type != 8) {
            Notify(error.message);
          } else {
            data.form.name = error.data.name;
            disabledFlag.value = true;
          }
        }
      }
    };

    const disabledName = computed(() => {
      if (route.name == RouterName.VISITOR_OWNER_EDIT) return true;
      if (disabledFlag.value) return true;
      return false;
    });

    return {
      showPicker,
      afterRead,
      ...toRefs(data),
      pageText,
      submit,
      validate,
      typePicker,
      generalPicker,
      moment,
      blurMobile,
      disabledName
    };
  }
};
</script>

<style lang="less" scoped>
.outset_div {
  background-color: rgb(246, 247, 250);
  min-height: 100vh;
  box-sizing: border-box;
  /deep/ .van-divider {
    width: 93%;
    margin: 0 0 0 10px;
    color: #ccd3df;
  }
  /deep/ .van-icon-arrow:before {
    color: #959fac;
  }
  .content {
    background-color: #fff;
    .item {
      height: 70px;
      width: 92%;
      margin: 15px 15px 0 15px;
      padding-top: 15px;
      //   border-bottom: 0.5px solid #CCD3DF;
      .label {
        font-family: PingFang-SC-ExtraLight;
        font-size: 15px;
        color: #2d333e;
        letter-spacing: 0;
        line-height: 15px;
        margin-bottom: 20px;
      }
      .required::after {
        margin-right: 2px;
        color: var(--van-field-required-mark-color);
        content: "*";
      }
      /deep/ .van-cell {
        padding: 0;
      }
      /deep/ .van-uploader__upload {
        width: 162px;
        height: 105px;
      }
    }
  }
  .btn {
    height: 58px;
    background: #ffffff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    padding: 12px 10px;
  }
  /deep/ .van-button--block {
    width: 95%;
    font-size: 17px;
  }
}
</style>
